export const SORT_OPTIONS = [
  {
    label: 'Date (desc)',
    value: 'date_desc',
    forceValue: {
      sort: 'date',
      sort_direction: 'desc',
    },
  },
  {
    label: 'Date (asc)',
    value: 'date_asc',
    forceValue: {
      sort: 'date',
      sort_direction: 'asc',
    },
  },
  {
    label: 'Name (desc)',
    value: 'title_desc',
    forceValue: {
      sort: 'title',
      sort_direction: 'desc',
    },
  },
  {
    label: 'Name (asc)',
    value: 'title_asc',
    forceValue: {
      sort: 'title',
      sort_direction: 'asc',
    },
  },
  {
    label: 'Rating (desc)',
    value: 'rating_desc',
    forceValue: {
      sort: 'rating',
      sort_direction: 'desc',
    },
  },
  {
    label: 'Rating (asc)',
    value: 'rating_asc',
    forceValue: {
      sort: 'rating',
      sort_direction: 'asc',
    },
  },
  // {
  //   label: 'Review count (desc)',
  //   value: 'review_count_desc',
  //   forceValue: {
  //     sort: 'review_count',
  //     sort_direction: 'desc'
  //   }
  // },
  // {
  //   label: 'Review count (asc)',
  //   value: 'review_count_asc',
  //   forceValue: {
  //     sort: 'review_count',
  //     sort_direction: 'asc'
  //   }
  // }
]
